import React from 'react'
import {
  Segment,
  Item,
  Button,
  Icon, ItemExtra, Rating
} from 'semantic-ui-react'
import {getStatus} from "../misc/Helpers";
import {Link} from "react-router-dom";
function Reviews({ loading, reviews }) {
  let reviewsList
  if (reviews.length === 0) {
    reviewsList = <Item key='no-trips'>Нет отзывов</Item>
  } else {
    reviewsList = reviews.map(review => {
      return (
        <Item key={review.id}>
          <Item.Content>
            <Item.Header>Отзыв о {review.target.name} с поездки {review.trip.fromCity} - {review.trip.toCity}
            </Item.Header>
            <Item.Meta>{new Date(review.trip.tripTime).toLocaleString('ru',
              {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: false
              })}</Item.Meta>
            <Item.Description>
              {review.notes}
            </Item.Description>
            <ItemExtra>
              <Rating icon="star" defaultRating={review.mark} maxRating={5} disabled />
            </ItemExtra>
            <Item.Extra>
              Отзыв оставил {review.author.name} {review.createdDate}
            </Item.Extra>
          </Item.Content>
        </Item>
      )
    })
  }

  return (
    <Segment loading={loading} color='blue'>
      <Item.Group divided unstackable relaxed>
        {reviewsList}
      </Item.Group>
    </Segment>
  )
}

export default Reviews
